import { getToken, privateHttpClient } from '../utils/httpClient';

export const getCountryList = async (index: number) => {
  const { data } = await privateHttpClient.get('/api/country', {
    headers: {
      'Content-type': 'application/json',
      'Authorization': `Bearer ${getToken()}`,
      // 'ApiKey' : getApiKeyForHotel()
    },
    params: {
      PageIndex: index,
      PageSize: 100
    }
  });

  return data;
};
